import {Equipment} from "./equipment";
import {Maintenance} from "./maintenance";
import {BaseModel} from "./base-model";
import {Utils} from "../utils";
import {FieldService} from "./field-service";

export class PhysicalAsset extends BaseModel {

  protected static self = PhysicalAsset;

  id: string;
  serialNumber: string;
  model: Equipment;
  modelId: string;
  fieldService: FieldService;
  fieldServiceId: string;
  deployedAt: number;
  lastMaintenance: Maintenance;

  public validate(): boolean {
    return !Utils.isEmpty(this.modelId) && !Utils.isEmpty(this.serialNumber) && this.deployedAt > 0;
  }
}
